import { create } from "zustand";

import { ModelsUser } from "@/schemas";

import type { SessionType, User } from "../types/storeType";

export const useSessionStore = create<SessionType>((set) => ({
    userInfo: {
        user_id: "",
    },
    accountInfo: null,
    setAccountInfo: (accountInfo: ModelsUser) => set({ accountInfo: accountInfo }),
    setUserInfo: (userInfo: User) => set({ userInfo: userInfo }),
    clear: () => set({ userInfo: { user_id: "" } }),
}));
